import type { LocationQuery, RouteLocationRaw } from 'vue-router'

import { parse as parseHash } from '@backmarket/utils/query-string/parse'
import { stringify as stringifyHash } from '@backmarket/utils/query-string/stringify'

const ALWAYS_ALLOWED_QUERY_KEYS = ['p', 'q']
const MIN_PRODUCTS_FOR_FILTERED_PAGE = 2

type RouteContext = {
  path: string
  query: LocationQuery
  hash: string
}

export function getUnknownQueryKeyRedirect(
  { path, query, hash }: RouteContext,
  openFilterKey: string | null,
  hasOpenFacetsError: boolean,
): RouteLocationRaw | null {
  if (hasOpenFacetsError) return null

  const allowedKeys = new Set([
    ...(openFilterKey ? [openFilterKey] : []),
    ...ALWAYS_ALLOWED_QUERY_KEYS,
  ])
  const hasUnknownKey = Object.keys(query).some((key) => !allowedKeys.has(key))
  if (!hasUnknownKey) return null

  const cleanQuery: LocationQuery = {}
  if (query.p != null) cleanQuery.p = query.p
  if (query.q != null) cleanQuery.q = query.q

  return { path, query: cleanQuery, hash }
}

export function getOpenFilterHashRedirect(
  { path, query, hash }: RouteContext,
  openFilterKey: string | null,
): RouteLocationRaw | null {
  if (!openFilterKey) return null

  const currentHashFilters = hash ? parseHash(hash.replace(/^#/, '')) : {}
  if (!(openFilterKey in currentHashFilters)) return null

  const { [openFilterKey]: _dropped, ...rest } = currentHashFilters
  const newHashBody = stringifyHash(rest)

  return { path, query, hash: newHashBody ? `#${newHashBody}` : '' }
}

export function getThinResultsRedirect(
  { path, query, hash }: RouteContext,
  openFilterKey: string | null,
  total: number,
): RouteLocationRaw | null {
  if (!openFilterKey || total >= MIN_PRODUCTS_FOR_FILTERED_PAGE) return null

  const { [openFilterKey]: _dropped, ...restQuery } = query

  return { path, query: restQuery, hash }
}
